/* Sunnah Goods page runtime.
   Merges each page's curated product notes (names, notes, categories) with live Shopify data
   (price, compare-at price, stock, variants, images), then hands the result to the page script.
   Cart, drawers and toasts go through window.SG from sg.js. */
(function () {
  'use strict';
  var d = document;
  function json(id, fb) { var el = d.getElementById(id); if (!el) return fb; try { return JSON.parse(el.textContent); } catch (e) { return fb; } }
  var CFG = json('sgx-cfg', {});
  var CUR = window.SGXCUR || json('sgx-cur', []);
  var LIVE = json('sgx-live', { p: {}, ord: [] });
  var LP = LIVE.p || {};
  delete LP.__;
  var queue = [], done = false;

  var SGX = window.SGX = { D: CFG, P: null, BY: {} };
  SGX.ready = function (fn) { if (done) fn(SGX.P); else queue.push(fn); };
  SGX.open = function (id, btn) { if (window.SG && SG.open) SG.open(id, btn); };
  SGX.close = function () { if (window.SG && SG.close) SG.close(); };
  var batching = 0;
  SGX.toast = function (m, c) { if (batching && /^Added/.test(m)) return; if (window.SG && SG.toast) SG.toast(m, c); };
  var money = SGX.money = function (v) { return '$' + Number(v).toFixed(2); };
  function norm(s) { return String(s == null ? '' : s).toLowerCase().replace(/\s*[,\/]\s*/g, ' / ').replace(/\s+/g, ' ').trim(); }
  function handleOf(p) { return p.h || String(p.url || '').split('/products/')[1] || ''; }
  function uniq(a) { var o = []; a.forEach(function (x) { if (o.indexOf(x) < 0) o.push(x); }); return o; }

  /* ---------- live data from /products/<handle>.js for products outside the page's collections ---------- */
  function fromJs(j) {
    function sz(u) { if (!u) return ''; u = String(u); return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=800'; }
    return {
      t: j.title, u: '/products/' + j.handle, ty: j.type || '', o: (j.options || []).map(function (o) { return o.name || o; }),
      img: (j.images || []).slice(0, 2).map(sz),
      v: (j.variants || []).map(function (v) { return [v.id, v.title, v.option1, v.option2, v.price, v.compare_at_price || 0, v.available ? 1 : 0]; })
    };
  }
  function fetchMissing(handles) {
    if (!handles.length) return Promise.resolve();
    return Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { if (j && j.variants) LP[h] = fromJs(j); })
        .catch(function () {});
    }));
  }

  /* ---------- merge: clothing-style and essentials products (v = [label, price, compare, available, id]) ---------- */
  function priceUp(p, ia, ip, ic) {
    var av = p.v.filter(function (x) { return x[ia]; }), base = av.length ? av : p.v;
    if (!base.length) return;
    p.p = Math.min.apply(null, base.map(function (x) { return x[ip]; }));
    var cv = base.find(function (x) { return x[ip] === p.p && x[ic] && x[ic] > x[ip]; });
    p.c = cv ? cv[ic] : null;
    p.frm = uniq(base.map(function (x) { return x[ip]; })).length > 1;
    p.save = p.c ? Math.round(100 * (1 - p.p / p.c)) : 0;
    p.soldout = !av.length;
  }
  function imgs(p, L) { if (L && L.img && L.img.length) p.img = [L.img[0], L.img[1] || L.img[0]]; }
  function mergeMx(p, L, split) {
    if (!L) { p.v = p.v.map(function (x) { return [x[0], x[1], x[2], 0, 0]; }); priceUp(p, 3, 1, 2); return p; }
    var single = L.v.length === 1 && /^default title$/i.test(L.v[0][1]);
    var lv = L.v.map(function (x) { return [single ? 'Default' : x[1], x[4] / 100, x[5] > x[4] ? x[5] / 100 : null, x[6] ? 1 : 0, x[0]]; });
    if (split) {
      p.v = p.v.map(function (x) {
        var m = lv.find(function (y) { return norm(y[0]) === norm(x[0]); }) || (p.v.length === 1 && lv.length === 1 ? lv[0] : null);
        return m ? [x[0], m[1], m[2], m[3], m[4]] : [x[0], x[1], x[2], 0, 0];
      });
    } else if (lv.length === 1 && p.v.length === 1) {
      p.v = [[p.v[0][0], lv[0][1], lv[0][2], lv[0][3], lv[0][4]]];
    } else {
      p.v = lv.map(function (y) {
        var c = p.v.find(function (x) { return norm(x[0]) === norm(y[0]); });
        return [c ? c[0] : y[0], y[1], y[2], y[3], y[4]];
      });
    }
    priceUp(p, 3, 1, 2);
    if (p.badge && /^Save \d+%$/.test(p.badge)) p.badge = p.save ? 'Save ' + p.save + '%' : '';
    imgs(p, L); p.url = L.u;
    return p;
  }
  /* ---------- merge: fragrance products (v = [option 1, option 2, price, compare, available, id]) ---------- */
  function mergeFrag(p, L) {
    var o = L.o || [];
    var single = L.v.length === 1 && /^default title$/i.test(L.v[0][1]);
    p.v = L.v.map(function (x) { return [single ? (p.v[0] ? p.v[0][0] : '') : x[2], o.length > 1 ? (x[3] || '') : '', x[4] / 100, x[5] > x[4] ? x[5] / 100 : null, x[6] ? 1 : 0, x[0]]; });
    if (!single && o.length && o[0] !== 'Title') p.o1 = o[0];
    p.o2 = o.length > 1 ? o[1] : null;
    if (/size/i.test(p.o1 || '')) { var s = uniq(p.v.filter(function (x) { return x[4]; }).map(function (x) { return x[0]; })); if (s.length) p.sz = s; }
    priceUp(p, 4, 2, 3);
    imgs(p, L); p.url = L.u;
    return p;
  }

  /* ---------- new products added to the collection after this page was designed ---------- */
  function guessBook(t) {
    t = t.toLowerCase();
    var cat = /qur'?an|tafs[ei]er|tajweed|juz/.test(t) ? 'quran' : /hadith|bukhari|muslim|riyad|nawawi/.test(t) ? 'hadith' : /prophet|seerah|nectar|stories|history|women around|great women/.test(t) ? 'seerah' : /prayer|salah|dua|supplication|fortress|jumu/.test(t) ? 'worship' : 'character';
    var fmt = /hardcover/.test(t) ? 'Hardcover' : /paperback/.test(t) ? 'Paperback' : /softcover/.test(t) ? 'Softcover' : 'Hardcover';
    var m = t.match(/(\d+)[- ]volume/); return { cat: cat, fmt: m ? 'Set' : fmt, vols: m ? +m[1] : 1, au: '' };
  }
  function shortName(t) { return String(t).split(/\s[–—-]\s|:\s|\s\(|,\s/)[0].replace(/\s+(hardcover|softcover|paperback)$/i, '').trim(); }
  function newMx(h, L, i) {
    var p = { k: 'n_' + h, n: shortName(L.t), img: [], v: [], url: L.u, d: '', line: '', opt: (L.o && L.o[0] && L.o[0] !== 'Title') ? L.o.join(' and ') : null, o: 900 + i };
    var pg = CFG.page, t = (L.t + ' ' + (L.ty || '')).toLowerCase();
    if (pg === 'books') Object.assign(p, guessBook(L.t), { line: '' });
    if (pg === 'tasbeeh') {
      var b = L.t.match(/(\d+)\s*beads/i), mm = L.t.match(/(\d+)\s*mm/i);
      Object.assign(p, { stone: shortName(L.t), beads: b ? +b[1] : 33, mm: mm ? +mm[1] : 10, mat: /wood/.test(t) ? 'wood' : 'stone' });
      p.line = p.beads + ' beads, ' + p.mm + 'mm';
    }
    if (pg === 'offers') p.cat = /oud|musk|fragrance|perfume|parfum|edp|oil/.test(t) ? 'fragrance' : /prayer|mat|tasbeeh|misbaha/.test(t) ? 'prayer' : /kohl|miswak|seed|honey|hijama|essential/.test(t) ? 'essentials' : 'clothing';
    if (pg === 'essentials') Object.assign(p, { h: h, ar: '', cat: 'other', facts: [], best: false });
    return mergeMx(p, L, false);
  }
  function newFrag(h, L, i) {
    var t = (L.t + ' ' + (L.ty || '')).toLowerCase();
    var spray = /edp|eau de|parfum|spray|cologne|extrait/.test(t), set = /discovery|sample|set/.test(t);
    var kind = set ? 'set' : spray ? 'spray' : /musk/.test(t) ? 'musk' : 'oil';
    var g = CFG.page === 'him' ? 'him' : CFG.page === 'her' ? 'her' : 'uni';
    var p = { h: h, n: shortName(L.t), by: '', kind: kind, g: g, fam: [], d: '', v: [], img: [], url: L.u,
      fmt: kind === 'oil' ? 'Fragrance oil' : kind === 'musk' ? 'Musk' : kind === 'set' ? 'Sets and samples' : (/extrait/.test(t) ? 'Extrait de Parfum' : 'Eau de Parfum'),
      o1: 'Size', o2: null, sig: false, nl: [], t: kind === 'spray' ? (/extrait/.test(t) ? 'extrait' : 'edp') : kind, sz: [], save: 0, o: 900 + i, top: '', heart: '', base: '' };
    mergeFrag(p, L);
    if (!p.sz.length) p.sz = uniq([].concat.apply([], p.v.map(function (x) { return (String(x[0]) + ' ' + String(x[1])).match(/\d+\s?ml/gi) || []; })));
    return p;
  }


  /* Product tags override the page data: "Scent: Musk", "Scent: Floral", "For: Her" / "For: Him" / "For: Unisex" */
  var FAMK = { oud: 'oud', incense: 'oud', amber: 'amber', spice: 'amber', spicy: 'amber', woods: 'woods', wood: 'woods', woody: 'woods', leather: 'woods', gourmand: 'gourmand', sweet: 'gourmand', vanilla: 'gourmand', floral: 'floral', flower: 'floral', fresh: 'fresh', citrus: 'fresh', musk: 'musk' };
  function tagFrag(p, L) {
    if (!p || !L || !L.tg || !L.tg.length) return p;
    var fams = [], g = null;
    L.tg.forEach(function (t) { var m = String(t).toLowerCase().match(/^\s*(scent|family|for)\s*:\s*(.+?)\s*$/); if (!m) return;
      if (m[1] === 'for') { var w = m[2]; g = /her|women|sister/.test(w) ? 'her' : /him|men|brother/.test(w) ? 'him' : 'uni'; }
      else { var k = FAMK[m[2].split(/[\s&,]+/)[0]]; if (k && fams.indexOf(k) < 0) fams.push(k); } });
    if (fams.length) p.fam = fams; if (g) p.g = g; return p;
  }
  /* ---------- build ---------- */
  function build() {
    var fam = CFG.fam, cnt = {}, have = {};
    function dh(h) { try { return decodeURIComponent(h).toLowerCase(); } catch (e) { return String(h).toLowerCase(); } }
    CUR.forEach(function (p) { var h = handleOf(p); cnt[h] = (cnt[h] || 0) + 1; have[h] = 1; have[dh(h)] = 1; });
    var out = [];
    CUR.forEach(function (p) {
      var h = handleOf(p), L = LP[h];
      if (fam === 'frag') {
        if (!L) return;
        mergeFrag(p, L); tagFrag(p, L);
        if (p.soldout) return;
        out.push(p);
      } else { out.push(mergeMx(p, L, cnt[h] > 1)); }
    });
    if (CFG.append) {
      uniq(LIVE.ord || []).forEach(function (h, i) {
        if (!h || have[h] || have[dh(h)] || !LP[h]) return; have[dh(h)] = 1;
        var L = LP[h]; if (!L.v.some(function (x) { return x[6]; })) return;
        out.push(fam === 'frag' ? tagFrag(newFrag(h, L, i), L) : newMx(h, L, i));
      });
      if (fam === 'ess') out.forEach(function (p, i) { if (!p.no) p.no = String(i + 1).padStart(2, '0'); });
    }
    return out;
  }

  /* ---------- static prices written into the page markup ---------- */
  function keyOf(p) { return p.k || p.h; }
  function fixStatic(P) {
    var BY = {}; P.forEach(function (p) { BY[keyOf(p)] = p; });
    d.querySelectorAll('[data-sgpr]').forEach(function (el) {
      var p = BY[el.dataset.sgpr]; if (!p) return;
      if (el.dataset.f === 'c') { if (p.c) el.textContent = money(p.c); else { var s = el.closest('s'); (s || el).hidden = true; } }
      else el.textContent = money(p.p);
    });
    d.querySelectorAll('[data-sgsum]').forEach(function (el) {
      var t = 0, ok = true; el.dataset.sgsum.split(',').forEach(function (k) { if (BY[k]) t += BY[k].p; else ok = false; });
      if (ok) el.textContent = money(t);
    });
    var re = /(<span data-sgpr="([^"]+)" data-f="(p|c)">)\$[\d,.]+(<\/span>)/g;
    function fixStr(s) { return s.replace(re, function (m, a, k, f, z) { var p = BY[k]; if (!p) return m; var v = f === 'c' ? p.c : p.p; return v ? a + money(v) + z : a + z; }); }
    function walk(o) { if (typeof o === 'string') return fixStr(o); if (Array.isArray(o)) return o.map(walk); if (o && typeof o === 'object') { Object.keys(o).forEach(function (k) { o[k] = walk(o[k]); }); } return o; }
    d.querySelectorAll('script[type="application/json"][data-sgfix]').forEach(function (s) {
      try { s.textContent = JSON.stringify(walk(JSON.parse(s.textContent))); } catch (e) {}
    });
    return BY;
  }

  /* ---------- cart ---------- */
  var pend = [], pendT = null;
  function flush() {
    var items = pend; pend = []; pendT = null; batching = 0;
    if (items.length && window.SG && SG.add) SG.add(items).catch(function () {});
  }
  function push(item, silent) {
    if (silent) { batching = 1; pend.push(item); if (!pendT) pendT = setTimeout(flush, 30); return; }
    if (window.SG && SG.add) SG.add([item]).catch(function () {});
  }
  function soldOut() { SGX.toast('Sorry, that option is sold out.'); }
  SGX.addMx = function (p, label, silent) {
    if (!p) return;
    var v = p.v.find(function (x) { return x[0] === label; }) || p.v.find(function (x) { return norm(x[0]) === norm(label); }), props = null;
    if (!v) { var av = p.v.filter(function (x) { return x[3]; }); if (av.length === 1 || (label && av.length)) { v = av[0]; if (label && label !== 'Default') props = { 'Your selection': label }; } }
    if (!v || !v[3] || !v[4]) { soldOut(); return; }
    var it = { id: v[4], quantity: 1 }; if (props) it.properties = props;
    push(it, silent);
  };
  SGX.addFrag = function (p, a, b) {
    if (!p) return;
    var v = p.v.find(function (x) { return x[0] === a && (!p.o2 || x[1] === b); });
    if (!v || !v[4] || !v[5]) { soldOut(); return; }
    push({ id: v[5], quantity: 1 });
  };

  /* ---------- 'More' pages kit: globals, quick-add sheet, reveals ---------- */
  function mxKit(P, BY) {
    window.MXP = P; window.MXBY = BY;
    window.MXMONEY = money; window.MXtoast = SGX.toast;
    window.MXopen = SGX.open; window.MXclose = SGX.close;
    window.MXadd = function (k, a, pr, silent) { SGX.addMx(BY[k], a, silent); return 0; };
    var $ = function (s, r) { return (r || d).querySelector(s); }, $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
    var qp = null, qa = null, q1 = null, q2 = null;
    var two = function (p) { return p.v.length > 1 && p.v.every(function (x) { return x[0].indexOf(' / ') > -1; }); };
    function names(p) { var o = p.opt || 'Option'; var m = o.split(' and '); return m.length > 1 ? [m[0], m[1].charAt(0).toUpperCase() + m[1].slice(1)] : [o, 'Colour']; }
    var esc = function (s) { return String(s).replace(/"/g, '&quot;'); };
    function openQuick(k, btn, pre) {
      var p = BY[k]; if (!p) return; var av = p.v.filter(function (x) { return x[3]; });
      if (av.length === 1 && !pre) { window.MXadd(k, av[0][0], av[0][1]); return; }
      qp = p; qa = pre || null; q1 = null; q2 = null;
      if (two(p) && pre) { var s = pre.split(' / '); q1 = s[0]; q2 = s[1]; }
      var sh = $('#mxq'); if (!sh) return;
      sh.querySelector('.mxq-h').innerHTML = '<img src="' + (p.img[0] || '') + '" alt=""><div><h2 id="mxq-title">' + p.n + '</h2>' + (p.d ? '<p>' + p.d + '</p>' : '') + '</div><button class="icon-btn" type="button" data-close aria-label="Close"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
      drawQ(); SGX.open('mxq', btn);
    }
    function drawQ() {
      var p = qp, v;
      if (two(p)) {
        var nm = names(p), n1 = nm[0], n2 = nm[1];
        var A = uniq(p.v.map(function (x) { return x[0].split(' / ')[0]; })), B = uniq(p.v.map(function (x) { return x[0].split(' / ')[1]; }));
        var ok = function (a, b) { return p.v.some(function (x) { return x[3] && x[0] === a + ' / ' + b; }); };
        if (q1 && q2 && !ok(q1, q2)) q2 = null;
        $('#mxq .mxq-b').innerHTML = '<div class="mxq-o"><h3>' + n1 + ': <span>' + (q1 || 'Choose one') + '</span></h3><div class="opts">' + A.map(function (a) { return '<button type="button" data-q1="' + esc(a) + '" aria-pressed="' + (q1 === a) + '" ' + (B.some(function (b) { return ok(a, b); }) ? '' : 'disabled') + '><span>' + a + '</span></button>'; }).join('') + '</div></div>' +
          '<div class="mxq-o"><h3>' + n2 + ': <span>' + (q2 || (q1 ? 'Choose one' : 'Choose ' + n1.toLowerCase() + ' first')) + '</span></h3><div class="opts sm">' + B.filter(function (b) { return p.v.some(function (x) { return x[0].slice(-(' / ' + b).length) === ' / ' + b && (!q1 || x[0].indexOf(q1 + ' / ') === 0); }); }).map(function (b) { return '<button type="button" data-q2="' + esc(b) + '" aria-pressed="' + (q2 === b) + '" ' + (q1 && ok(q1, b) ? '' : 'disabled') + ' class="' + (q1 ? '' : 'wait') + '"><span>' + b + '</span></button>'; }).join('') + '</div></div>';
        qa = q1 && q2 ? q1 + ' / ' + q2 : null; v = p.v.find(function (x) { return x[0] === qa; });
      } else {
        $('#mxq .mxq-b').innerHTML = '<div class="mxq-o"><h3>' + (p.opt || 'Option') + ': <span>' + (qa || 'Choose one') + '</span></h3><div class="opts">' + p.v.map(function (x) { return '<button type="button" data-qv="' + esc(x[0]) + '" aria-pressed="' + (qa === x[0]) + '" ' + (x[3] ? '' : 'disabled') + '><span>' + x[0] + '</span><small>' + money(x[1]) + '</small></button>'; }).join('') + '</div></div>';
        v = p.v.find(function (x) { return x[0] === qa; });
      }
      $('#mxq .mxq-a').innerHTML = '<button class="mx-btn" type="button" id="mxq-add" ' + (v ? '' : 'disabled') + '>' + (v ? 'Add to cart, ' + money(v[1]) : 'Choose ' + (p.opt || 'an option').toLowerCase()) + '</button><a href="' + p.url + '">See full details</a>';
    }
    window.MXquick = openQuick;
    d.addEventListener('click', function (e) {
      var a = e.target.closest('[data-add]'); if (a) { openQuick(a.dataset.add, a, a.dataset.pre || null); return; }
      var q = e.target.closest('[data-qv]'); if (q && !q.disabled) { qa = q.dataset.qv; drawQ(); return; }
      var a1 = e.target.closest('[data-q1]'); if (a1 && !a1.disabled) { q1 = a1.dataset.q1; drawQ(); return; }
      var a2 = e.target.closest('[data-q2]'); if (a2 && !a2.disabled) { q2 = a2.dataset.q2; drawQ(); return; }
      if (e.target.closest('#mxq-add') && qp) { var v = qp.v.find(function (x) { return x[0] === qa; }); if (v) { window.MXadd(qp.k, v[0], v[1]); SGX.close(); } }
    });
    var rv = $$('.mx-rv');
    if ('IntersectionObserver' in window) { var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px' }); rv.forEach(function (x) { io.observe(x); }); }
    else rv.forEach(function (x) { x.classList.add('in'); });
  }

  /* ---------- start ---------- */
  function start() {
    var need = uniq(CUR.map(handleOf).filter(function (h) { return h && !LP[h]; }));
    fetchMissing(need).then(function () {
      var P = build();
      SGX.P = P;
      var BY = fixStatic(P); SGX.BY = BY;
      if (CFG.fam === 'mx') mxKit(P, BY);
      done = true;
      queue.forEach(function (fn) { try { fn(P); } catch (e) { if (window.console) console.error(e); } });
      queue = [];
    });
  }
  if (/[?&]customer_posted=true/.test(location.search)) setTimeout(function () { SGX.toast('Thank you. You are subscribed.'); }, 600);
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();
